import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';

function* getRegularusersGroup({ payload: { signal, id } }) {
  try {
    const { data } = yield call(fetch, { api: api.modifiers.regularusers.get, id, signal });

    yield put(actions.getRegularusersGroupDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getRegularusersGroupFailed,
      endpoint: api.modifiers.regularusers.get.url
    });
  }
}

export const getRegularusersGroupSaga = takeEvery(types.GET_REGULARUSERS_GROUP_REQUEST, getRegularusersGroup);